import { RefObject, useCallback, useEffect } from 'react';

export const useClickOutside = (
  ref: RefObject<HTMLElement>,
  onClickOutside: (e: Event) => void,
  excludeRefs: Array<RefObject<HTMLElement>>,
): void => {
  const handleClickOutside = useCallback(
    (e: MouseEvent) => {
      // containsExcludedRefs prevents to capture other onclick on the ref it contains
      // native event listeners will always be executed before react events and for some reason stoping the event propagation does not work
      const containsExcludedRefs = excludeRefs.find((excludeRef) =>
        excludeRef.current?.contains(e.target as Node),
      );

      if (ref.current?.contains(e.target as Node) || containsExcludedRefs) {
        return;
      }
      onClickOutside(e);
    },
    [excludeRefs, onClickOutside, ref],
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);
};
